/**
 * Supplier delivery days come back in whatever order they were saved
 * ("wed", "fri", "tue", "mon"). Show them Monday → Sunday.
 */

const DAY_ORDER = ['mon', 'tue', 'wed', 'thu', 'fri', 'sat', 'sun']

const dayRank = day => {
  const index = DAY_ORDER.indexOf(
    String(day || '')
      .trim()
      .slice(0, 3)
      .toLowerCase(),
  )
  return index === -1 ? DAY_ORDER.length : index
}

/**
 * Mon → Sun, keeping each day's original text. Blanks and repeats are
 * dropped; anything that isn't a weekday keeps its place at the end.
 *
 * @param {string[]|null|undefined} days
 * @returns {string[]}
 */
export function sortDeliveryDays(days) {
  if (!Array.isArray(days)) return []
  const seen = new Set()
  const unique = []
  days.forEach(day => {
    const text = String(day || '').trim()
    const key = text.toLowerCase()
    if (!text || seen.has(key)) return
    seen.add(key)
    unique.push(text)
  })
  return unique
    .map((day, index) => ({ day, index, rank: dayRank(day) }))
    .sort((a, b) => a.rank - b.rank || a.index - b.index)
    .map(({ day }) => day)
}

const titleCase = day => {
  const text = String(day || '').trim()
  return text ? text.charAt(0).toUpperCase() + text.slice(1).toLowerCase() : ''
}

/**
 * Mon → Sun in title case ("mon", "TUE" → "Mon", "Tue"), so basket,
 * checkout and supplier cards all read the same.
 *
 * @param {string[]|null|undefined} days
 * @returns {string[]}
 */
export function formatDeliveryDays(days) {
  return sortDeliveryDays(days).map(titleCase)
}
